import cookie from 'react-cookies';

export function isIOS() {
  return /iPhone|iPad|iPod/i.test(window.navigator.userAgent);
}

export function isAndroidOS() {
  return /Android/i.test(window.navigator.userAgent);
}

export function isIOSApp() {
  const { navigator } = window;
  const standalone = navigator.standalone;
  const userAgent = navigator.userAgent.toLowerCase();
  const safari = /safari/.test(userAgent);
  const ios = /iphone|ipod|ipad/.test(userAgent);

  if (ios) {
    if (!standalone && !safari) {
      return true;
    }
  }
  return false;
}

export function isAndroidApp() {
  const userAgent = window.navigator.userAgent.toLowerCase();
  const android = /android/.test(userAgent);
  return android && /welltory/.test(userAgent);
}

export function isWebviewApp() {
  return isIOSApp() || isAndroidApp();
}

export function isMobile() {
  return /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);
}

export function getCookie(name) {
  const cookies = window.document.cookie.split(';');
  const cookie = cookies.map((cookie) => {
    const matches = cookie.match(new RegExp(name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  });
  const cookieWithoutUndefined = cookie.filter((item) => { if (item !== 'undefined') { return item;} return null; })
  return cookieWithoutUndefined.pop();
}

export function setCookie(name, value) {
  cookie.save(name, value, { domain: '.welltory.com', path: '/' });
}

export function getLanguage() {
  let language = '';
  if (window.navigator.languages && window.navigator.languages.length > 0) {
    const languages = window.navigator.languages.join(',');
    const ruPos = languages.indexOf('ru');
    const enPos = languages.indexOf('en');
    if (ruPos === -1 && enPos !== -1) {
      language = 'en';
    }
    else if (ruPos !== -1 && enPos === -1) {
      language = 'ru';
    }
    else if (ruPos < enPos) {
      language = 'ru';
    }
    else if (ruPos > enPos) {
      language = 'en';
    }
  }
  else {
    language = window.navigator.language || 'ru';
  }
  language = language.split('-')[0];
  if (language !== 'ru' && language !== 'en') {
    language = 'en';
  }
  return language;
}
